import { Container, Row, Col } from "reactstrap";
import mapIcon from "../../assets/images/icons/maps-and-flags.png";
import * as userAction from "../../actions/user-action-type";
import HeaderBanner from "../../components/banners/HeaderBanner";
import cx from "classnames";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-multi-lang";
import ContentLoader from "react-content-loader";
import headBanner from "../../assets/images/headerImages/view-all-destiations-AND-Gallery.jpg";

import './offerdestination.scss'
import "../BookYourExperience/style.scss";

function RenderBookCard(props) {
  const { name, img, id, url_slug, hover_text, description, location } = props;
  const history = useHistory();
  const t = useTranslation();

  const top = () => (
    <div className="top-content">
      <div>
        {name ?
          <p className="rating">
            <img src={mapIcon} alt="rating" />
            {name}
          </p> :
          <p></p>
        }
      </div>
    </div>
  );

  const MouseOver = (event) => {
    if (event.target.querySelector(".dec"))
      event.target.querySelector(".dec").style.display = 'block';
  }

  const MouseOut = (event) => {
    if (event.target.querySelector(".dec"))
      event.target.querySelector(".dec").style.display = "none";
  }

  const bottom = () => (
    <div className="bottom-content">
      <div>
        {localStorage.getItem("user_language") == "en" ? (
          <>
            <p className="title pr-4">{name}</p>
            <p className="dec" style={{ "display": "block", "opacity": "0.8" }}>
              {hover_text || description || 'Discover amazing experiences at this destination'}
            </p>
          </>
        ) : (
          <>
            <p className="title pr-4">{name}</p>
            <p className="dec" style={{ "display": "block", "opacity": "0.8" }}>
              {hover_text || description || 'اكتشف تجارب مذهلة في هذه الوجهة'}
            </p>
          </>
        )}
      </div>
    </div>
  );
  const image = `https://api.discovershurooq.ae/cdn-cgi/image/width=1000,quality=85,format=auto/files/${img}`;
  return (
    <div
      className="book-exp-card"
      onClick={() => {
        // Push to dataLayer for GTM tracking
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'package_click',
            'package_data': {
              'title': name || '',
              'price': '0',
              'original_price': '0',
              'destination': '',
              'url_slug': window.location.origin + '/d/' + url_slug
            }
          });
          
          console.log('GTM Push - Package Click (Destination):', {
            'event': 'package_click',
            'package_data': {
              'title': name || '',
              'price': '0',
              'original_price': '0',
              'destination': '',
              'url_slug': window.location.origin + '/d/' + url_slug
            }
          });
        }
        history.push(`../d/${url_slug}`);
      }}
      onMouseEnter={MouseOver} 
      onMouseLeave={MouseOut}  
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="content">
        {top()}
        {bottom()}
      </div>
    </div>
  );
}

function OfferDestinations(props) {
  const [loader, setLoader] = useState(true);
  const t = useTranslation();
  const history = useHistory();
  localStorage.setItem("pathname", history.location.pathname);

  const {
    destinationData,
    getDestinationData,
  } = props;

  const [offerredDestinations, setOfferredDestination] = useState([])

  useEffect(() => {
    const toShow = ["Discover Mleiha", "Al Montazah", "Al Noor Island", "City Sightseeing Sharjah"]
    setOfferredDestination(
      destinationData.filter(dest => toShow.includes(dest.name))
    )
  }, [destinationData])
  
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });

    const formData = new FormData();
    formData.append("action", "destinations");
    getDestinationData(formData);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoader(false), 2000);
  }, [destinationData]);

  const renderLoader = () => (
    <Row>
      {["", "", "", "", "", ""].map((data, index) => (
        <Col md={6} key={"bookData" + index} className="book-exp-card-col">
          <ContentLoader
            speed={2}
            viewBox="0 0 638 450"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
          >
            <rect x="1" y="0" rx="30" ry="30" width="638" height="380" />
            <rect x="19" y="396" rx="3" ry="3" width="300" height="8" />
            <rect x="19" y="410" rx="3" ry="3" width="300" height="8" />
            <rect x="500" y="410" rx="3" ry="3" width="100" height="8" />
          </ContentLoader>
        </Col>
      ))}
    </Row>
  );

  const copyCouponCode = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (window && window.navigator && window.navigator.clipboard) {
        navigator.clipboard.writeText("SEESHARJAH")
        .then(() => {
          alert("Coupon code copied...")
        }).catch((err) => {
          alert("Could not copy coupon code.") 
        })
    }
    else alert("Could not copy coupon code.")
  }

  const renderData = () => (
    <Row>
      <Col md={12}>
        <div className="promoCoupon" onClick={copyCouponCode}>
          <div className="couponContent">
            <div className="off">
              20%
            </div>
            <div className="useCode">
              <span>
                off with code
              </span>
              <span className="code">
                'SEESHARJAH'
              </span>
            </div>
          </div>
          <span className="couponInfo">
            For following destinations only.
          </span>
        </div>
      </Col>
      {offerredDestinations.length == 0 ? <Col><div style={{ justifyContent: 'center', display: 'flex' }}><p>No Packages Found</p></div></Col> : <div></div>}
      {offerredDestinations.map((data, index) =>
        <Col xs={12} md={4} key={"bookData" + index} className="book-exp-card-col">
          <RenderBookCard {...data} />
        </Col>
      )
      }
    </Row>
  );

  return (
    <>
      <HeaderBanner backgroundImage={headBanner} />
      <section className="book-youre-experience-section">
        <Container>
          {loader ? renderLoader() : renderData()}
        </Container>
      </section>
    </>
  );
}
const mapStateToProps = ({
  user: {
    destinationData,
  },
}) => ({
  destinationData,
});

const mapDispatchToProps = {
  getDestinationData: userAction.getDestinationData,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OfferDestinations));
